import { render, staticRenderFns } from "./InteresDelete.vue?vue&type=template&id=724f2b2e"
import script from "./InteresDelete.vue?vue&type=script&lang=js"
export * from "./InteresDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports